import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0, // Data is immediately stale - always refetch
            gcTime: 0, // Don't cache data at all
            retry: 0, // default was 1 but doubles reports in te backend !
            refetchOnWindowFocus: false,
            refetchOnMount: 'always', // Always fetch on component mount
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            // Only log non-HTTP errors
            // HTTP errors are already logged by Axios interceptor in client.ts
            if (!(error instanceof AxiosError)) {
                // This is a non-HTTP error (parsing, thrown error, etc.)
                console.error(
                    'React Query error:',
                    `[${JSON.stringify(query.queryKey)}]`,
                    error instanceof Error ? error.message : String(error)
                );
            }
        },
    }),
    mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
            // Only log non-HTTP errors
            // HTTP errors are already logged by Axios interceptor in client.ts
            if (!(error instanceof AxiosError)) {
                console.error(
                    'React Query mutation error:',
                    `[${JSON.stringify(mutation.options.mutationKey)}]`,
                    error instanceof Error ? error.message : String(error)
                );
            }
        },
    }),
});